import { Grid, ListItem, Paper, Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { ActionPlanStatus } from '../../../sic-lib/enums/EngageActionPlansEnums';
import { EngageActionPlan } from '../../../sic-lib/types/EngageActionPlan';

interface Props {
    engageActionPlan: EngageActionPlan;
    selectedId: number | undefined;
    onSelectPlan: React.Dispatch<number>;
}

export default function AutomationDialogItem({
    engageActionPlan,
    selectedId,
    onSelectPlan,
}: Props) {
    const { classes, cx } = useStyles();

    const getColor = () => {
        switch (engageActionPlan.status) {
            case ActionPlanStatus.Active:
                return classes.active;
            case ActionPlanStatus.Completed:
                return classes.completed;
            case ActionPlanStatus.Paused:
                return classes.paused;
            case ActionPlanStatus.Failed:
                return classes.failed;
            default:
                return classes.default;
        }
    };

    const handleSelectedPlan = () => {
        if (engageActionPlan.id !== undefined) {
            onSelectPlan(engageActionPlan.id);
        }
    };

    return (
        <Paper
            variant="outlined"
            sx={{ p: 1 }}
            component="div"
            onClick={handleSelectedPlan}
            className={cx(
                classes.listItem,
                selectedId === engageActionPlan.id ? classes.selected : '',
            )}
        >
            <Stack direction="column" gap={1}>
                <ListItem className={classes.listItem}>
                    <Grid
                        container
                        columnSpacing={1}
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid item md={7}>
                            <Typography variant="subtitle1">
                                {engageActionPlan.description}
                            </Typography>
                        </Grid>
                        <Grid item md={5} display="flex" justifyContent="flex-end">
                            <Typography variant="body1" className={cx(classes.default, getColor())}>
                                {engageActionPlan.status}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
            </Stack>
        </Paper>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    listItem: {
        cursor: 'pointer',
        flexWrap: 'wrap',
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
    },
    selected: {
        backgroundColor: theme.palette.menuListHover.main,
    },
    default: {
        flexWrap: 'wrap',
        backgroundColor: theme.palette.grey[300],
        paddingInline: theme.spacing(1),
        borderRadius: 8,
        color: 'white',
    },
    active: {
        backgroundColor: theme.palette.conversationTimelinePaper.light,
    },
    completed: {
        backgroundColor: theme.palette.conversationTimelinePaper.main,
    },
    paused: {
        backgroundColor: theme.palette.warning.light,
    },
    failed: {
        backgroundColor: theme.palette.error.light,
    },
}));
